import { createContext } from 'react';

import { Nullable, TutorialContextValue } from '@/types';

export const TutorialContext = createContext<Nullable<TutorialContextValue>>(null);
